import React, { useEffect, useState } from "react";

import { ChargeTable } from "./chargeTable";
import { Info } from "./info";
import { ShowError } from "../../../components/error";
import { Title } from "./title";
import { fetchHcfDetails } from "./api";
import { QualificationRateOverrides } from "./qualificationRateOverrides";
import { Qualification } from "@src/appV2/Admin/Qualifications/types";
import { showSuccessToast } from "@src/appV2/lib/Notifications";
import { handleApiError } from "src/utils/errors";

interface TimeChargeProps {
  hcfId: string;
  hcfType: string;
  updateFacility: (data: unknown) => Promise<unknown>;
  qualifications: Qualification[];
}

function TimeCharge(props: TimeChargeProps): JSX.Element {
  const { hcfId, updateFacility, qualifications } = props;
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [details, setDetails] = useState<any>();
  const [error, setError] = useState();

  useEffect(() => {
    fetchHcfDetails(hcfId, "ratesTable").then(setDetails).catch(setError);
  }, [hcfId]);

  const updateLocal = (data) => {
    // `data` is undefined if saveFacility's retrieveUser refresh failed
    // (swallowed there). The optimistic update already reflects the
    // submitted value, so leave local state alone in that case.
    if (!data?.facility?.ratesTable) {
      return;
    }
    setDetails((prev) => ({ ...prev, ratesTable: data.facility.ratesTable }));
  };

  const handleChange = (data) => {
    const [path] = Object.keys(data);
    const [day, slot] = path.split(".");
    const nextValue = data[path];
    const previousValue = details?.ratesTable?.[day]?.[slot];

    setDetails((prev) => ({
      ...prev,
      ratesTable: {
        ...prev?.ratesTable,
        [day]: { ...prev?.ratesTable?.[day], [slot]: nextValue },
      },
    }));

    updateFacility({
      facilityId: hcfId,
      ratesTable: {
        [day]: {
          [slot]: nextValue,
        },
      },
    })
      .then(updateLocal)
      .then(() => showSuccessToast("Time charge has been updated."))
      .catch((error) => {
        handleApiError(error);
        setDetails((prev) => ({
          ...prev,
          ratesTable: {
            ...prev?.ratesTable,
            [day]: { ...prev?.ratesTable?.[day], [slot]: previousValue },
          },
        }));
      });
  };

  return (
    <div>
      <ShowError error={error} message="Unable to fetch workplace Charge" />
      <Title>
        Shift Time Charge (added to HCF Base Charge for shifts with each time category)
        {/* @ts-expect-error FIXME this wrong type */}
        <Info
          text={
            <span>
              If a shift starts on these days /<br />
              times, the respective charge
              <br />
              will be added to the HCF Base
              <br />
              Charge.
            </span>
          }
        />
      </Title>
      <ChargeTable rates={details?.ratesTable} onChange={handleChange} />
      <QualificationRateOverrides
        hcfId={hcfId}
        qualifications={qualifications}
        updateFacility={updateFacility}
      />
    </div>
  );
}

export { TimeCharge };
